
import React, { useState } from "react";
import "../styles/Contact.css";
import { sendEmail } from '../services/emailService';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    service: '',
    message: '',
    phone: ''
  });
  const [formStatus, setFormStatus] = useState({ message: '', type: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setFormStatus({ message: '', type: '' });

    const result = await sendEmail({
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      service: formData.service,
      message: formData.message,
    });

    if (result.success) {
      setFormStatus({
        message: result.message,
        type: 'success'
      });
      // Reset form
      setFormData({
        name: '',
        email: '',
        service: '',
        message: '',
        phone: ''
      });
      // Clear message after 5 seconds
      setTimeout(() => setFormStatus({ message: '', type: '' }), 5000);
    } else {
      setFormStatus({
        message: result.message,
        type: 'error'
      });
    }

    setIsSubmitting(false);
  };

  return (
    <div className="contact-page">

      {/* HERO VIDEO */}
      <div className="contact-hero">
        <video autoPlay loop muted playsInline>
          <source src="17599593-uhd_3840_2160_30fps.mp4" type="video/mp4" />
        </video>

        <h1>Contact Us</h1>
      </div>

      {/* CONTACT SECTION */}
      <div className="contact-container">

        {/* LEFT TEXT */}
        <div className="contact-left">
          <h2>Connect With Us</h2>
          <p>
            Ready to grow your business with powerful digital marketing strategies?
            Let’s connect and build something amazing together.
          </p>

          {/* SOCIAL LINKS */}
          <div className="social-icons">
            <a href="https://www.facebook.com/share/1CosMw2VHY/" target="_blank" rel="noreferrer"><i className="fab fa-facebook-f"></i></a>
            <a href="https://www.instagram.com/namodigitalhub?igsh=MWRjMGV6Z2d1a2pkdg==" target="_blank" rel="noreferrer"><i className="fab fa-instagram"></i></a>
            <a href="https://www.linkedin.com/company/namodigitalhub" target="_blank" rel="noreferrer"><i className="fab fa-linkedin-in"></i></a>
          </div>

          {/* WHATSAPP */}
          <a
            href="https://wa.me/917033006888"
            target="_blank"
            rel="noreferrer"
            className="whatsapp-btn"
          >
            <i className="fab fa-whatsapp"></i> Chat on WhatsApp
          </a>
        </div>

        {/* RIGHT FORM */}
        <form
          className="contact-form"
          onSubmit={handleFormSubmit}
        >
          <input 
            type="text" 
            name="name" 
            placeholder="Your Name" 
            value={formData.name}
            onChange={handleInputChange}
            required 
          />
          <input 
            type="email" 
            name="email" 
            placeholder="Email Address" 
            value={formData.email}
            onChange={handleInputChange}
            required 
          />

          <input
            type="tel"
            name="phone"
            placeholder="Phone (optional)"
            value={formData.phone}
            onChange={handleInputChange}
          />

          <select 
            name="service" 
            value={formData.service}
            onChange={handleInputChange}
            required
          >
            <option value="">Select Service</option>
            <option>SEO</option>
            <option>Google Ads</option>
            <option>Meta Ads</option>
            <option>Social Media Marketing</option>
            <option>Video Editing</option>
            <option>Graphic Designing</option>
            <option>Branding</option>
            <option>Web Development</option>
            <option>Landing Page</option>
            <option>E-commerce</option>
          </select>

          <textarea
            name="message"
            placeholder="Project Description"
            rows="5"
            value={formData.message}
            onChange={handleInputChange}
            required
          ></textarea>

          {formStatus.message && (
            <div className={`form-message form-message-${formStatus.type}`}>
              {formStatus.message}
            </div>
          )}

          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Sending...' : 'Send Message'}
          </button>
        </form>

      </div>

    </div>
  );
}

export default Contact;